import React from 'react';
import { Search } from 'lucide-react';
import { Card } from '../../atoms/Card';
import { Input } from '../../atoms/Input';
import { Button } from '../../atoms/Button';
import type { LikeTargetType } from '../../../services/likesService';

type FilterType = 'all' | LikeTargetType;

export interface LikeSearchBarProps {
  searchQuery: string;
  targetFilter: FilterType;
  onSearchQueryChange: (query: string) => void;
  onTargetFilterChange: (filter: FilterType) => void;
  onSearch: (e: React.FormEvent) => void;
}

const FILTERS: { value: FilterType; label: string }[] = [
  { value: 'all', label: 'Tümü' },
  { value: 'news', label: 'İçerikler' },
  { value: 'comment', label: 'Yorumlar' },
];

export const LikeSearchBar = ({
  searchQuery,
  targetFilter,
  onSearchQueryChange,
  onTargetFilterChange,
  onSearch,
}: LikeSearchBarProps) => {
  return (
    <Card className="mb-6">
      <form
        onSubmit={onSearch}
        className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center"
      >
        <div className="flex-1 relative min-w-0">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
          <Input
            type="text"
            placeholder="Kullanıcı adı, içerik veya ID ile ara..."
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            className="pl-10 w-full"
          />
        </div>
        <div className="flex gap-1 flex-shrink-0">
          {FILTERS.map((f) => (
            <button
              key={f.value}
              type="button"
              onClick={() => onTargetFilterChange(f.value)}
              className={`px-3 py-1.5 text-sm rounded-md font-medium transition-colors ${
                targetFilter === f.value
                  ? 'bg-accent text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        <Button type="submit" variant="primary" className="flex-shrink-0 w-full sm:w-auto">
          Ara
        </Button>
      </form>
    </Card>
  );
};
